var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M25.4 10.5c6.793 0 12.3 5.507 12.3 12.3 0 6.793-5.507 12.3-12.3 12.3a12.25 12.25 0 01-7.138-2.282.375.375 0 01-.076-.529l1.079-1.417a1 1 0 011.241-.29C22.538 31.595 24.17 32.1 25.4 32.1a9.3 9.3 0 100-18.6c-4.73 0-8.635 3.53-9.223 8.1h3.256a1 1 0 01.717 1.697l-4.633 4.766-.02.02a1 1 0 01-1.414-.02L9.45 23.297a1 1 0 01.717-1.697l2.99.001C13.76 15.371 19.012 10.5 25.4 10.5z", fill: "currentColor", fillRule: "nonzero", stroke: "none", strokeWidth: 1 })));
});
